import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { MAYORIZACION_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function MayorizacionPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${MAYORIZACION_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
